import { render, staticRenderFns } from "./Gerenzx.vue?vue&type=template&id=26cefb1f&scoped=true"
import script from "./Gerenzx.vue?vue&type=script&lang=js"
export * from "./Gerenzx.vue?vue&type=script&lang=js"
import style0 from "./Gerenzx.vue?vue&type=style&index=0&id=26cefb1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cefb1f",
  null
  
)

export default component.exports